import { gql } from '@apollo/client';

const REMOVE_STUDENT_SETTINGS = gql`
  mutation removeStudentSettingsMutation($where: StudentSettingsWhereInput!) {
    removeStudentSettings(where: $where) {
      count
    }
  }
`;

export default REMOVE_STUDENT_SETTINGS;
